import { CalendarDays } from 'lucide-react';

/**
 * FIX-B36 (FQ-052 / QX-751) - what ui/DateInput and ui/DateTimeInput draw over the real field:
 *  - the dd/mm/yyyy[ hh:mm] text at the field's START side (right in RTL), positioned by the
 *    field's direction - the text itself is dir=ltr inside, so `start-3` is no longer "left";
 *  - ONE calendar icon of the system at the END side; the browser's own indicator is hidden in
 *    CSS (index.css, `input.date-dmy`), so nothing covers the day digits. The icon does not take
 *    clicks: a click reaches the field and the global DatePickerLayer opens.
 */
export default function DateFieldOverlay({ text, placeholder, ltr, disabled }: {
  text: string;
  placeholder: string;
  ltr: boolean;
  disabled?: boolean;
}) {
  return (
    <>
      <span
        aria-hidden="true"
        // eslint-disable-next-line no-restricted-syntax -- forced-LTR field needs a physical side
        className={`pointer-events-none absolute inset-y-0 ${ltr ? 'left-3' : 'start-3'} flex items-center text-sm ${text ? 'text-surface-900' : 'text-surface-500'} ${disabled ? 'opacity-60' : ''}`}
      >
        <span dir="ltr">{text || placeholder}</span>
      </span>
      <CalendarDays
        size={16}
        aria-hidden="true"
        // eslint-disable-next-line no-restricted-syntax -- forced-LTR field needs a physical side
        className={`pointer-events-none absolute top-1/2 -translate-y-1/2 ${ltr ? 'right-3' : 'end-3'} text-text-3 ${disabled ? 'opacity-60' : ''}`}
      />
    </>
  );
}
